import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { TranslateService } from '@ngx-translate/core';
import { environment } from '@env/environment';
import { AuthService } from '@app/core/services/auth.service';
import { HTTP_STATUS_CODE } from '@app/core/constants/system.constants';

@Component({
  selector: 'app-setup-2fa',
  templateUrl: './setup-2fa.component.html',
  styleUrls: ['./setup-2fa.component.scss']
})
export class Setup2faComponent implements OnInit {
  bgLoginPath = environment.bgLogin;
  logoPath = environment.logo;
  form!: FormGroup;
  isSubmitted = false;
  isLoading = false;
  loadingQr = true;
  qrDataUri: string | null = null;
  secret: string | null = null;
  recoveryCodes: string[] = [];
  enrolled = false;

  constructor(
    private fb: FormBuilder,
    private router: Router,
    private toastr: ToastrService,
    private translate: TranslateService,
    private authService: AuthService
  ) {}

  ngOnInit(): void {
    // Màn ép thiết lập chạy trong phiên chờ MFA; vào thẳng URL không có ngữ cảnh → về login
    if (!sessionStorage.getItem('ssoReqParams')) {
      this.router.navigate(['/login']).then();
      return;
    }
    this.form = this.fb.group({ code: [null, Validators.required] });
    this.loadSetup();
  }

  loadSetup(): void {
    this.loadingQr = true;
    this.authService.mfaSetup().subscribe({
      next: (res) => {
        this.loadingQr = false;
        if (res?.code === HTTP_STATUS_CODE.SUCCESS) {
          this.qrDataUri = res.data?.qrDataUri;
          this.secret = res.data?.secret;
        } else {
          this.toastr.error(res?.message);
        }
      },
      error: (err) => {
        this.loadingQr = false;
        this.toastr.error(err?.error?.message || this.translate.instant('common.error.system'));
      }
    });
  }

  get f() {
    return this.form.controls;
  }

  submit(): void {
    this.isSubmitted = true;
    if (this.form.invalid) return;
    this.isLoading = true;
    this.authService.mfaEnable(this.form.value.code).subscribe({
      next: (res) => {
        this.isLoading = false;
        if (res?.code === HTTP_STATUS_CODE.SUCCESS) {
          this.recoveryCodes = res.data?.recoveryCodes || [];
          this.enrolled = true;
        } else {
          this.toastr.error(res?.message);
        }
      },
      error: (err) => {
        this.isLoading = false;
        this.toastr.error(err?.error?.message || this.translate.instant('common.error.system'));
      }
    });
  }

  continueToApp(): void {
    this.redirectToAuthorize();
  }

  backToLogin(): void {
    this.router.navigate(['/login']).then();
  }

  private redirectToAuthorize(): void {
    const state = sessionStorage.getItem('ssoState') || '';
    const reqParams = sessionStorage.getItem('ssoReqParams') || '';
    window.location.href = `${environment.backend.sso}/oauth2/authorize?state=${state}&${reqParams}`;
  }
}
